import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  @media only screen and (min-width: 600px) {
    position: absolute;
    /* width: calc(100%-130px); */
    height: 60px;
    top: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${Colors.lightWhite};
    /* padding-left:150px ; */
  }
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;
export const Container2 = styled.div`
  @media only screen and (min-width: 600px) {
    position: absolute;
    width: 100vw;
    height: 60px;
    top: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${Colors.lightWhite};
  }
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

export const HeaderDiv = styled.div`
  height: 80px;
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  
`;

export const TopBarDiv = styled.div`
  width: calc(100vw - 230px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* padding-left: 10px;
  padding-right: 10px; */
  /* background-color:  ${Colors.primary}; */
  `;

export const TopBarNavDiv = styled.div`
/* margin-left: 190px; */
margin-top: 95px;
width: 100%;
overflow-x: scroll;
&::-webkit-scrollbar {
  display: none;
}
scrollbar-width: none;
${STYLES.HorizontalLeftAlign};
`;

export const TopBarNav = styled.section`
  border: 1px solid ${Colors.primary};
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  /* min-width: 100px; */
  background-color: ${props => props.isSelected ? Colors.primary : Colors.whiteThemeColor};
  p {
    margin: 3px;
    padding: 3px;
    color: ${props => props.isSelected ? Colors.whiteThemeColor : Colors.primary};
    font-size: 12px;
    pointer-events: none;
  }
`;

export const SearchDiv = styled.div`
  width: 30%;
  background-color: ${Colors.darkWhite};
`;

export const OptionsDiv = styled.div`
  width: 20%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 5px;
  /* background-color: ${Colors.darkWhite}; */
`;

export const MobileHeader = styled.div`
  @media only screen and (min-width: 600px) {
    display: none;
  }
  @media only screen and (max-width: 600px) {
    box-sizing: border-box;
    height: 70px;
    position: absolute;
    width: 100%;
    background-color: ${Colors.primary};
    ${STYLES.spaceBetween};
    padding-left: 10px;
    padding-right: 10px;
    z-index: 600;
  }
`;
